import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import months from 'constants/months';
import moment from 'moment';
import { DashboardState } from 'types';
import { getRole } from 'utils/storage.service';
const prevMonth = moment().subtract(1, 'months');

export const initialState: DashboardState = {
  loading: false,
  sales: [],
  ytdDetails: [],
  leadershipDetails: [],
  kpi: {},
  filter: {
    year: prevMonth.year(),
    month: months[prevMonth.month()].toLowerCase(),
    role: getRole(),
    hqfilter: true,
    manager: '',
    countryCode:'us',
  },
  applyFilter:false,
  onHqFilter:null,
  reps: [],
  leadershipFilter: [],
  countryCode:'us',
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setSales: (state, { payload }: PayloadAction<any>) => {
      state.sales = payload;
    },
    setYtdDetails: (state, { payload }: PayloadAction<any>) => {
      state.ytdDetails = payload || [];
    },
    setLeadership: (state, { payload }: PayloadAction<any>) => {
      state.loading = false;
      state.leadershipDetails = payload || [];
    },
    setLeadershipBoard: (state, { payload }: PayloadAction<any>) => {
      state.leadershipBoard = payload || [];
    },
    setKpi: (state, { payload }: PayloadAction<any>) => {
      state.kpi = payload || {};
    },
    setFilter: (state, { payload }: PayloadAction<any>) => {
      const filter = { ...payload };

      state.filter = { ...state.filter, ...filter };
    },
    setLeadershipFilter: (state, { payload }: PayloadAction<any>) => {
      const filter = { ...payload };

      state.leadershipFilter = { ...filter };
    },
    setApplyFilter: (state, { payload }: PayloadAction<any>) => {
      state.applyFilter = payload;
    },
    setOnHqFilter: (state, { payload }: PayloadAction<any>) => {
      state.onHqFilter = payload;
    },
    setReps: (state, { payload }: PayloadAction<any>) => {
      state.reps = payload;
    },

    setCountryCode: (state, { payload }: PayloadAction<any>) => {
      state.countryCode = payload;
    }
  }
});

export const {
  setSales,
  setYtdDetails,
  setLeadership,
  setLeadershipBoard,
  setKpi,
  setFilter,
  setApplyFilter,
  setOnHqFilter,
  setReps,
  setLeadershipFilter,
  setCountryCode
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
